import { useEffect, useMemo } from 'react'

import { TAbsoluteLocale } from '@src/config/i18n.config'
import type { TRegionDetail } from '@src/server-side/api/fetch-region-details'
import { noop } from '@src/utils/functions/utils'

import { checkRegionChanged } from '../utils'

const useRegionSwitchHandler = ({
  locale,
  regionDetails,
  showConfirmationModal,
}: {
  locale: TAbsoluteLocale
  regionDetails: TRegionDetail
  showConfirmationModal: (locale: TAbsoluteLocale, callback: () => void) => void
}) => {
  const { isRegionChange, targetLocale } = useMemo(() => {
    return checkRegionChanged({
      locale,
      regionDetails,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // Run only once on mount - we don't want to recheck region changes after initial load

  useEffect(() => {
    if (isRegionChange) {
      showConfirmationModal(targetLocale as TAbsoluteLocale, noop)
    }
  }, [isRegionChange, targetLocale, showConfirmationModal, regionDetails])
}

export default useRegionSwitchHandler
